<template>
  <div class="wrapper">
    <div class="only-mobile">
      <div class="search">
        <input type="text" placeholder="검색어를 입력해 주세요" v-model="q" />
        <img src="@/assets/img/ic_search.svg" />
      </div>
      <div class="btn-wrap">
        <button
          v-bind:class="[selectedButton === 'All' ? 'active' : '']"
          @click="selectQ('All')"
        >
          전체
        </button>
        <button
          v-bind:class="[selectedButton === 'join' ? 'active' : '']"
          @click="selectQ('join')"
        >
          가입 및 탈퇴
        </button>
        <button
          v-bind:class="[selectedButton === 'order' ? 'active' : '']"
          @click="selectQ('order')"
        >
          주문접수
        </button>
        <button
          v-bind:class="[selectedButton === 'delivery' ? 'active' : '']"
          @click="selectQ('delivery')"
        >
          배송
        </button>
        <button
          v-bind:class="[selectedButton === 'pay' ? 'active' : '']"
          @click="selectQ('pay')"
        >
          결제
        </button>
        <button
          v-bind:class="[selectedButton === 'etc' ? 'active' : '']"
          @click="selectQ('etc')"
        >
          서비스 및 기타
        </button>
      </div>
    </div>
    <div class="qna-wrap">
      <qna-list
        v-for="(result, idx) in selectedQuestions"
        :question="result"
        :idx="idx"
        :selectIdx="selectIdx"
        :key="idx"
        @expandQuestion="expandQuestion(idx)"
      />
    </div>
  </div>
</template>

<script>
import qnaList from "@/views/Services/Faq/list";

export default {
  metaInfo: {
    title: "자주 묻는 질문",
  },
  components: {
    qnaList,
  },
  methods: {
    expandQuestion(idx) {
      this.selectIdx === idx ? (this.selectIdx = null) : (this.selectIdx = idx);
      // this.selectedQuestions[idx].expand = !this.selectedQuestions[idx].expand;
    },
    selectQ(val) {
      this.reset();
      this.category = val;
      if (val === "All") {
        this.selectedButton = val;
        this.selectAll();
        return;
      }
      this.selectedButton = val;
      this.selectedQuestions = this.questions[val];
    },
    selectAll() {
      const sq = this.questions;
      this.selectedQuestions = this.selectedQuestions.concat(
        sq.join,
        sq.order,
        sq.delivery,
        sq.pay,
        sq.etc
      );
    },
    reset() {
      Object.assign(this.$data, this.$options.data());
    },
  },
  data() {
    return {
      selectedButton: "All",
      selectedQuestions: [],
      q: "",
      category: "All",
      selectIdx: null,
      questions: {
        join: [
          {
            title: "회원가입은 어떻게 하나요?",
            content: `우측 상단 [회원가입] 클릭 후 [관리자] 또는 [구성원] 계정 유형으로 회원가입 하실 수 있어요. 

                      ☑️ 관리자 계정으로 가입하기
                      디버가 처음이신 고객님은 [관리자] 계정으로 가입해 주세요. [관리자] 계정은 고객님의 법인/개인 사업체에서 대표로 사용하실 계정 유형이에요. [관리자] 계정은 하위에 여러 개의 [구성원] 계정을 둘 수 있으며, 구성원의 주문내역 확인 및 통계관리가 가능해요. 또한, [관리자] 계정에서 등록한 결제수단(월정산, 카드결제 등)을 승인된 [구성원] 계정에서 공용으로 사용할 수 있어요.

                      ☑️ 구성원 계정으로 가입하기
                      기존에 회원가입이 되어있는 [관리자] 계정의 하위 구성원으로 회원가입 할 수 있는 유형이에요. 구성원은 가입 이후 디버의 모든 서비스를 바로 이용하실 수 있으나, [관리자] 계정의 결제수단을 사용하기 위해서는 관리자의 승인이 필요해요.`,
            expand: false,
            q: true,
          },
          {
            title: "회원 정보 변경은 어떻게 하나요?",
            content:
              "비밀번호, 이름, 연락처, 사업자정보 등 회원정보에 대한 변경은 우측 상단 [마이페이지] 에서 변경하실 수 있어요.",
            expand: false,
            q: true,
          },
          {
            title: "회원탈퇴는 어떻게 하나요?",
            content:
              "회원 탈퇴를 원하시는 경우, 디버 대표 메일 (hello@dvercorp.co.kr) 또는 우측 하단 [문의] 버튼을 클릭하여 요청 주시면 회원탈퇴 처리를 도와드릴게요.",
            expand: false,
            q: true,
          },
        ],
        order: [
          {
            title: "주문접수는 어떻게 하나요?",
            content: `[주문접수] 페이지에서 출발지/도착지 정보, 배송유형, 배송수단, 물품정보를 입력한 후 [바로 주문] 버튼을 클릭해 주세요. 결제수단 확인 후 [결제하기] 버튼을 클릭하여 결제가 완료되면 접수가 완료돼요.

                      여러 건의 주문을 한 번에 결제하는 경우, [장바구니 담기] 버튼을 클릭하여 장바구니에 담아주세요. [장바구니] 페이지에서 원하는 주문을 선택한 후 [주문하기] 버튼을 클릭하여 결제가 완료되면 접수가 완료돼요.
                    `,
            expand: false,
            q: true,
          },
          {
            title: "주문취소는 어떻게 하나요?",
            content: `주문 취소는 [주문내역] 페이지에서 가능해요. 상황에 따라 취소위약금이 발생할 수 있으며 디버 운영팀의 최종 승인 이후 취소처리를 해드려요. 주문취소 관련 문의는 고객센터(1544-4805) 또는 우측 하단 [문의] 버튼을 이용해 주세요.`,
            expand: false,
            q: true,
          },
          {
            title: "즉시픽업과 예약픽업의 차이는 무엇인가요?",
            content: `☑️ 즉시픽업
                      배송물품 준비가 완료되어 접수 직후부터 바로 픽업이 가능한 경우 [즉시픽업]을 선택해 주세요. 일반적으로 주문접수 완료 이후 20-30분 이내에 배송파트너님이 출발지에 도착해요.

                      ☑️ 예약픽업
                      주문접수 시간 기준으로 1시간 이후의 시간부터 픽업시간으로 선택할 수 있어요. 특정시간 이후 픽업을 원하시는 경우 [예약픽업]을 선택해 주세요. 예약해 주신 픽업시간 이후에 배송파트너님이 출발지에 도착해요.
`,
            expand: false,
            q: true,
          },
          {
            title: "즐겨찾기는 어떻게 이용하나요?",
            content: `주소검색 화면 목록을 보시면 주소정보 좌측에 📌핀 아이콘이 있어요. 회색 핀을 누르면 해당 주소가 즐겨찾기에 추가되고 파란색 핀으로 변경돼요. 파란색 핀을 누르면 해당 주소가 즐겨찾기에서 해제되고 회색 핀으로 변경돼요.`,
            expand: false,
            q: true,
          },
        ],
        delivery: [
          {
            title: "어떤 물품을 보낼 수 있나요?",
            content: `아래 명시된 취급금지 물품 외에는 배송이 가능해요. 취급금지 물품 발송에 따른 사고/분실 발생시 보내신 고객님이 전적인 책임을 부담하게 돼요.

            • 현금, 어음, 수표, 유가증권 등 현금화 사용 가능한 물품
            • 독극물(농약 등), 폭발물, 총포류, 도검류, 생동물 및 동물 사체 등
`,
            expand: false,
            q: true,
          },
          {
            title: "배송 가능한 물품의 종류와 크기는 어떻게 구분되나요?",
            content: `보내실 수 있는 물품의 종류는 [서류], [소박스], [대박스], [기타]에요. [소박스]는 A4박스 크기이며 오토바이 배송이 가능해요. [대박스]는 사과박스보다 큰 크기이며 크기 또는 무게에 따라 오토바이 배송이 어려울 수 있어요. [기타]를 선택한 경우 물품에 대한 상세 설명을 입력해 주세요.`,
            expand: false,
            q: true,
          },
          {
            title: "배송물품 분실 또는 파손시 보상 받을 수 있나요?",
            content: `디버는 배송 중 발생하는 분실 및 파손에 대해 최대 50만원 한도의 보상을 받을 수 있는 수하물 보험에 가입되어 있어요. 50만원 이상의 물품을 보내는 경우, 한 사고당 최대 1억원까지 보상 가능한 보험을 적용할 수 있으며 이때 추가 비용이 발생할 수 있어요. 보상 관련 문의는 고객센터(1544-4805) 또는 우측 하단 [문의] 버튼을 통해 주시면 자세하게 답변 드릴게요.`,
            expand: false,
            q: true,
          },
          {
            title: "경유, 왕복 배송은 어떻게 신청하나요?",
            content: `경유지가 포함된 주문의 경우 주문접수 시 [경유지 추가] 버튼을 클릭하여 경유지를 추가해 주세요. [경유지 추가] 기능을 통해 서로 다른 2개 이상의 도착지로의 배송을 보다 저렴한 가격으로 이용하실 수 있어요.

                      디버는 왕복 배송 기능을 제공하고 있지 않아요. [경유지 추가] 기능을 이용하여 마지막 도착지와 출발지가 동일하도록 주문해 주시면 왕복으로 배송이 가능해요.`,
            expand: false,
            q: true,
          },
          {
            title: "일반배송과 급송배송은 어떤 차이가 있나요?",
            content: `☑️ 일반배송
                      일반배송은 배송파트너가 여러 건을 묶어서 함께 배송해요. 단건 배송은 아니지만 배송금액을 아낄 수 있는 배송 유형이에요. 배송시간에 여유가 있는 경우 이용해 주세요.

                      ☑️ 급송배송
                      급송배송은 단건 배송을 원칙으로 하고 있어요. 더 빠른 배송이 필요한 경우 이용해 주세요. (단, 도로사정에 따라 배송시간이 길어 질 수 있어요.)
`,
            expand: false,
            q: true,
          },
          {
            title: "배송소요시간의 기준은 어떻게 되나요?",
            content: `☑️ 즉시픽업 배송소요시간
                      즉시픽업 유형을 선택한 경우 출발지에서 도착지까지의 내비게이션 시간을 기준으로 배송소요시간이 계산돼요. 여기에 배송파트너 매칭시간, 픽업지 이동 및 주차시간, 물품 픽업을 위한 건물 내 이동시간, 상/하차 시간 등의 부가시간 추가가 필요한 경우 합산된 배송소요시간이 표기돼요.

                      ☑️ 예약픽업 배송소요시간
                      예약픽업 유형을 선택한 경우 ‘서울시 평균 차량속도’를 반영하여 배송소요시간이 계산돼요. 출발지/도착지에 서울이 아닌 곳 또는 혼잡도가 높은 주요업무지구(강남, 종로/을지로, 여의도, 구로 등)가 포함된 경우, 고속도로를 이용해야 하는 경우, 악천후 등의 상황에서는 예상 배송소요시간과 실제 소요시간에 차이가 있을 수 있어요.
`,
            expand: false,
            q: true,
          },

          {
            title: "배송파트너 배정은 어떻게 되나요?",
            content:
              "배송 출발지로부터의 거리, 파트너 평점 등을 종합한 점수가 높은 파트너에게 우선 배정돼요. 파트너 평점은 수행 오더에 대한 픽업/배송 완료시간 준수 여부 등에 따라 다르게 부여돼요.",
            expand: false,
            q: true,
          },
          {
            title: "배정된 배송파트너의 정보는 어떻게 확인할 수 있나요?",
            content: `카카오톡 알림톡에서 보내는 분, 받는 분, 신청인의 휴대전화번호로 배송파트너 정보와 실시간 위치를 제공해 드려요. 기재하신 번호가 휴대전화번호가 아닌 경우 알림톡 수신이 어려우니 연락처를 기재하실 때 휴대전화번호가 맞는지 꼭 확인해 주세요. 배송파트너에 대한 정보는 [주문내역] – [상세보기] 페이지에서도 확인하실 수 있어요.`,
            expand: false,
            q: true,
          },
        ],
        pay: [
          {
            title: "결제는 어떻게 하나요?",
            content: `사전등록한 카드로 선결제가 진행되며 원활한 배송을 위해 현금결제 또는 착불결제는 불가해요. 결제하실 카드는 [마이페이지]-[결제수단]에서 신규 추가 또는 삭제하실 수 있어요.`,
            expand: false,
            q: true,
          },
        ],
        etc: [
          {
            title: "디버 서비스를 이용하면 어떤 점이 좋은가요?",
            content: `디버는 국내 최저 수준의 중계 수수료율로 운영되는 크라우드 소싱 기반의 퀵 서비스 플랫폼이에요. 따라서 고객님은 더욱 저렴하게 서비스 이용이 가능하며, 배송파트너는 기존 퀵 배송 대비 더 많은 수익을 보장 받을 수 있어요. 또한, 디버는 오토바이와 승용차 운임이 동일해요. 배송파트너들이 보유한 다양한 배송수단을 통해 기존 오토바이로 배송하기 모호했던 물품도 더욱 안전하고 합리적인 가격으로 보내실 수 있어요.`,
            expand: false,
            q: true,
          },
          {
            title: "서비스 가능 지역은 어떻게 되나요?",
            content:
              "디버는 전국에서 운영 중에요. 단, 일부 지방권의 경우 협력중인 배송사를 통해 배송될 수 있어요.",
            expand: false,
            q: true,
          },
        ],
      },
    };
  },
  mounted() {
    this.selectAll();
  },
  watch: {
    q(val) {
      val = val.replace(/ /g, "");
      if (val) {
        for (let i = 0; i < this.selectedQuestions.length; i += 1) {
          const title = this.selectedQuestions[i].title.replace(/ /g, "");
          if (!title.includes(val)) {
            this.selectedQuestions[i].q = false;
          }
          if (title.includes(val)) {
            this.selectedQuestions[i].q = true;
          }
        }
      }
      if (!val) {
        this.selectQ(this.category);
      }
    },
  },
};
</script>

<style src="./index.css" scoped />
